const NoReports = ({ page, type }) => {
  return (
    <div className="no-reports">
      {type === 'noData' ? (
        <p className="no-reports-1">No Results available</p>
      ) : (
        <p className="no-reports-1">
          No {page === 'journals' ? ' Journals ' : ' Reports '}
          selected
        </p>
      )}
      {type !== 'noData' && (
        <p className="no-reports-2">Please select a report type to generate the report.</p>
      )}
    </div>
  );
};

export default NoReports;
